import { object as zodObject, string as zodString, array as zodArray } from 'zod';
import { toTypedSchema } from '@vee-validate/zod';

// Individual security question schema
export const securityQuestionSchema = zodObject({
  question: zodString().min(1, 'Une question est requise'),
  answer: zodString().min(1, 'Une réponse est requise').max(255, 'La réponse est trop longue'),
  customQuestion: zodString().optional(),
  id: zodString().or(zodString().length(0)).optional()
}).refine((data) => {
  // If "Question personnalisée" is selected, customQuestion must be provided
  if (data.question === 'Question personnalisée') {
    return data.customQuestion && data.customQuestion.trim().length > 0;
  }
  return true;
}, {
  message: 'Veuillez saisir votre question personnalisée',
  path: ['customQuestion']
});

// Security questions form schema
export const securityQuestionsFormSchema = zodObject({
  questions: zodArray(securityQuestionSchema).min(1, 'Au moins une question de sécurité est requise')
});

// Typed schema for VeeValidate
export const securityQuestionsValidationSchema = toTypedSchema(securityQuestionsFormSchema);

export type SecurityQuestionForm = {
  question: string;
  answer: string;
  customQuestion?: string;
  id?: string;
};

export type SecurityQuestionsForm = {
  questions: SecurityQuestionForm[];
};